import { css } from 'aphrodite';
import * as React from 'react';
import { useHistory, useRouteMatch } from 'react-router';
import { ICustomSurvey, ICustomSurveyResponse } from '../../../models/Api';
import { CustomSurveyConfirmation } from './CustomSurveyConfirmation';
import { CustomSurveyResponseForm } from './CustomSurveyResponseForm';
import { styleSheet } from './styles';

interface IProps {
	survey: ICustomSurvey;
}

export const CustomSurveyResponse = ({ survey }: IProps) => {
	const { params: urlParams = {}, path: matchPath } = useRouteMatch<{
		token?: string;
	}>();

	const [surveyResponse, setSurveyResponse] = React.useState<ICustomSurveyResponse>(null);
	const [editResponse, setEditResponse] = React.useState<boolean>(false);
	const h = useHistory<{ response?: ICustomSurveyResponse }>();

	const onResponseSubmitted = (response: ICustomSurveyResponse) => {
		if (editResponse) {
			setEditResponse(false);
		}
		if (response.token && response.token !== urlParams.token) {
			h.replace({
				pathname: matchPath.replace(':token?', encodeURIComponent(response.token)),
				state: { response },
			});
		}
	};

	const switchToEditResponse = () => {
		setEditResponse(true);
	};

	return (
		<div className={css(styleSheet.container)}>
			{surveyResponse?.id && !editResponse ? (
				<CustomSurveyConfirmation
					survey={survey}
					surveyResponse={surveyResponse}
					onChangeResponseClick={switchToEditResponse}
				/>
			) : (
				<CustomSurveyResponseForm
					survey={survey}
					surveyResponse={surveyResponse}
					setSurveyResponse={setSurveyResponse}
					onResponseSubmitted={onResponseSubmitted}
				/>
			)}
		</div>
	);
};
